module.exports = __webpack_public_path__ + "static/media/gten.cd637aeb.png";